
import { words } from "lodash";
import React, { FC, useState, useEffect, memo } from "../../../lib/teact/teact";
import { copyTextToClipboard } from "../../../util/clipboard";
import Button from "../../ui/Button";
import { LotScreenSettings } from "../config/uiconfig";
import worker from "../setupWorker";
import Checkbox from "../../ui/Checkbox";
import { ContactsApi } from "../restapi/contactsApi";
import DropdownMenu from "../../ui/DropdownMenu";
import MenuItem from "../../ui/MenuItem";
import { BotConfigScreen } from "./BotConfigScreen";
import ChanSoHang from "./ChanSoHang";
import DanhSachNhom from "./danhSachNhom";
import HanMucToanBo from "./hanMucToanBo";
import RadioGroup from "../../ui/RadioGroup";
type OwnProps = {
    onChangeScreen: (preScreen: LotScreenSettings) => void;

}
const BotConfig: FC<OwnProps> = ({
    onChangeScreen,
}) => {
    const [state, setState] = useState({
        botReg: `bot_reg:${localStorage['access_token']}`,
        botCfg: {
            userId: 0,
            autoPhanTich: 0,
            autoBaoLoi: 0,
            autoTraLaiSoVuot: 0,
            autoTraLaiQuaGio: 0,
            chenTieuDeTinTraLai: 0,
            autoOk: 0,
            autoChangeMien: 0,
            kieuTraQuaGio:0,
            nhanTinTuBot: 0,

        },
        currentScreen: BotConfigScreen.BOT_CFG_MAIN,
    })
    useEffect(() => {
        ContactsApi.getBotConfig().then(res => {
            if (res) {
                setState(prev => ({ ...prev, botCfg: res.data }))
            }
        })
    }, [])
    function SetConfig(fieldName: string, value: boolean) {
        const tmp: any = state.botCfg
        const n = value ? 1 : 0
        tmp[fieldName] = n
        ContactsApi.setBotConfig(tmp).then(res => {
            if (res) {
                setState(prev => ({ ...prev, botCfg: tmp }))
            }
        })
    }
    function SetKieuTraQuaGio(fieldName: string, value: number) {
        const tmp: any = state.botCfg
         
        tmp[fieldName] = value
        ContactsApi.setBotConfig(tmp).then(res => {
            if (res) {
                setState(prev => ({ ...prev, botCfg: tmp }))
            }
        })
    }
    function handleMenuChange(screen: BotConfigScreen) {
        setState(prev => ({ ...prev, currentScreen: screen }))
    }
    return (
        <div className='form-content nogap'>
            <div className="form-header">
                <div className="form-header left-panel">
                    <Button
                        round
                        size="default"
                        color="translucent"
                        onClick={() => onChangeScreen(LotScreenSettings.CONTACT_LIST_SCREEN)}

                    >
                        <i
                            className='icon icon-arrow-left'
                            aria-hidden
                        />
                    </Button>

                    <div>Thiết lập Bot Telegram</div>
                </div>
                <div className=" form-header right-panel">
                    <DropdownMenu positionX="right">
                        <MenuItem onClick={() => handleMenuChange(BotConfigScreen.BOT_CFG_MAIN)}>Cấu hình Bot</MenuItem>
                        <MenuItem onClick={() => handleMenuChange(BotConfigScreen.BOT_CFG_CHAN_SO_HANG)}>Chặn số hàng</MenuItem>
                        <MenuItem onClick={() => handleMenuChange(BotConfigScreen.BOT_HAN_MUC_TOAN_BO)}>Hạn mức toàn bộ hệ thống</MenuItem>
                        <MenuItem onClick={() => handleMenuChange(BotConfigScreen.BOT_CFG_DANH_SACH_NHOM)}>Danh sách nhóm telegram</MenuItem>
                    </DropdownMenu>
                </div>
            </div>

            {
                state.currentScreen == BotConfigScreen.BOT_CFG_MAIN &&
                <div>
                    <div>Copy mã bên dưới, gửi vào nhóm có bot @loto88bot (Bạn phải là người tạo nhóm), hoặc trực tiếp gửi mã này cho bot @loto88bot để đăng ký</div>
                    <div className=" editable-div">
                        {state.botReg}
                    </div>
                    <div className=" common-container-row center">
                        <div style="width:200px;">
                            <Button size="smaller"
                                onClick={() => {
                                    copyTextToClipboard(state.botReg)
                                    worker.postMessage({ type: 'showsnackbar', data: 'Đã copy vào bộ nhớ' })
                                }}
                            >
                                <i className=" icon icon-copy"></i>
                                Copy
                            </Button>
                        </div>
                    </div>
                    <div className=" common-container-row">
                        <div>
                            <Checkbox label="Tự động chuyển miền " checked={state.botCfg.autoChangeMien == 1}
                                subLabel="Tự động xác định miền nhận tin (MB,MT,MN) theo khung giờ quay số"
                                onCheck={(c: boolean) => SetConfig("autoChangeMien", c)}
                            ></Checkbox>
                            <Checkbox label="Tự động phân tích tin" checked={state.botCfg.autoPhanTich == 1}
                                subLabel="Tất cả các tin gửi vào bot sẽ được tự động phân tích"
                                onCheck={(c: boolean) => SetConfig("autoPhanTich", c)}
                            ></Checkbox>
                            <Checkbox label="Tự động báo lỗi" checked={state.botCfg.autoBaoLoi == 1}
                                subLabel="Phân tích lỗi, sẽ gửi thông báo lỗi vào nhóm, hoặc người dùng"
                                onCheck={(c: boolean) => SetConfig("autoBaoLoi", c)}
                            ></Checkbox>
                            <Checkbox label="Tự động trả lời" checked={state.botCfg.autoOk == 1}
                                subLabel="Các tin phân tích thành công sẽ được thông báo tới người gửi"
                                onCheck={(c: boolean) => SetConfig("autoOk", c)}
                            ></Checkbox>
                            <Checkbox label="Tự động trả lại số vượt" checked={state.botCfg.autoTraLaiSoVuot == 1}
                                subLabel="Những bộ số vượt quá hạn mức sẽ tự động trả lại"
                                onCheck={(c: boolean) => SetConfig("autoTraLaiSoVuot", c)}
                            ></Checkbox>
                            <Checkbox label="Tự động trả lại quá giờ" checked={state.botCfg.autoTraLaiQuaGio == 1}
                                subLabel="Trong tin có mã cược vượt quá giờ chốt sẽ trả lại cả tin"
                                onCheck={(c: boolean) => SetConfig("autoTraLaiQuaGio", c)}
                                
                            ></Checkbox>
                            <RadioGroup name ="KieuTraLai" 
                            onChange={(value,event)=>{ SetKieuTraQuaGio("kieuTraQuaGio",Number(value))}} 
                            options={[
                                { value: '1', label: "Trả cả tin" },
                                { value: '2', label: "Trả đài quá giờ" },

                            ]}
                            disabled={state.botCfg.autoTraLaiQuaGio == 0}
                            selected={state.botCfg.kieuTraQuaGio+""}
                            >

                            </RadioGroup>
                            <Checkbox label="Tin trả lại chèn tiêu đề" checked={state.botCfg.chenTieuDeTinTraLai == 1}
                                subLabel="Nếu tắt chỉ hiển thị nội dung tin trả lại, thuận lợi cho việc copy, chuyển tiếp"
                                onCheck={(c: boolean) => SetConfig("chenTieuDeTinTraLai", c)}
                            ></Checkbox>
                            <Checkbox label="Nhận tin từ bot trả và cân chuyển" checked={state.botCfg.nhanTinTuBot == 1}
                                subLabel="Check vào nếu bạn muốn nhận tin từ bot trả lại và bot cân chuyển"
                                onCheck={(c: boolean) => SetConfig("nhanTinTuBot", c)}
                            ></Checkbox>
                        </div>
                    </div>
                </div>
            }
            {
                state.currentScreen == BotConfigScreen.BOT_CFG_CHAN_SO_HANG &&
                <ChanSoHang />
            }
            {
                state.currentScreen == BotConfigScreen.BOT_CFG_DANH_SACH_NHOM &&
                <DanhSachNhom />
            }
            {
                state.currentScreen == BotConfigScreen.BOT_HAN_MUC_TOAN_BO &&
                <HanMucToanBo />
            }
        </div>
    )
}
export default memo(BotConfig)